import { AnimatePresence } from "framer-motion";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { Dashboard } from "./Dashboard/Dashboard";
import { ExportPage } from "./ExportPage/ExportPage";
import { ImportPage } from "./ImportPage/ImportPage";
import { ModelsPage } from "./ModelsPage/ModelsPage";
import { TransformPage } from "./TransformPage/TransformPage";

let navigateFn: (url: string) => any | undefined;
export function navigate(url: string) {
    navigateFn(url);
}

export function AnimatedRoutes(props: {}) {
    const location = useLocation();
    navigateFn = useNavigate();

    return (
        <AnimatePresence exitBeforeEnter>
            <Routes location={location} key={location.pathname}>
                <Route path="/" element={<Dashboard />} />
                <Route path="/import" element={<ImportPage />} />
                {/* <Route path="/types" element={<TypesPage />} /> */}
                <Route path="/transform" element={<TransformPage />} />
                <Route path="/models" element={<ModelsPage />} />
                <Route path="/export" element={<ExportPage />} />
            </Routes>
        </AnimatePresence>
    );
};
